import React, { createContext, useState } from "react";

export const AppContext = createContext();

export const AppProvider = ({ children }) => {
  const [datosCompartidos, setDatosCompartidos] = useState({});
  const [isFormCompleted, setIsFormCompleted] = useState(false); // Nuevo estado para el formulario

 // console.log("datos Compartidos:", datosCompartidos);
 // console.log("Formulario completado:", isFormCompleted);

  return (
    <AppContext.Provider
      value={{
        datosCompartidos,
        setDatosCompartidos,
        isFormCompleted,
        setIsFormCompleted, // Exponer función para actualizar el estado
      }}
    >
      {children}
    </AppContext.Provider>
  );
};

export default AppContext;